export const ROLE_ADMIN = 'Admin';
export const ROLE_SUPER_ADMIN = 'SuperAdmin';
export const ROLE_USER = 'User';
export const ROLE_EMPLOYEE = 'Angestellter';
export const ROLE_EMPLOYEE_EN = 'Employee';

export const ROLE_SELECT = language => {
  const roles = [
    {_id: ROLE_USER, name: language === 'en' ? 'Collector' : 'Sammler'},
    {
      _id: ROLE_EMPLOYEE,
      name: language === 'en' ? ROLE_EMPLOYEE_EN : ROLE_EMPLOYEE,
    },
    {_id: ROLE_ADMIN, name: ROLE_ADMIN},
    {_id: ROLE_SUPER_ADMIN, name: ROLE_SUPER_ADMIN},
  ];
  return roles;
};

export function getTranslatedRole(role) {
  console.log(role);
  let {name} = ROLE_SELECT().find(({_id}) => _id === role) || {};

  console.log(name);
  return name || role;
}



// WEBPACK FOOTER //
// ./src/constants/userConstants.js